import {TypographyOptions} from '@mui/material/styles/createTypography';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    h7?: React.CSSProperties;
    h8?: React.CSSProperties;

    l1?: React.CSSProperties;
    l2?: React.CSSProperties;
    l3?: React.CSSProperties;
    l4?: React.CSSProperties;
    l5?: React.CSSProperties;
    l6?: React.CSSProperties;
    l7?: React.CSSProperties;
    l8?: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h7?: React.CSSProperties;
    h8?: React.CSSProperties;

    l1?: React.CSSProperties;
    l2?: React.CSSProperties;
    l3?: React.CSSProperties;
    l4?: React.CSSProperties;
    l5?: React.CSSProperties;
    l6?: React.CSSProperties;
    l7?: React.CSSProperties;
    l8?: React.CSSProperties;
  }
}

// Augment own types
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h7?: true;
    h8?: true;

    l1?: true;
    l2?: true;
    l3?: true;
    l4?: true;
    l5?: true;
    l6?: true;
    l7?: true;
    l8?: true;
  }
}

export const typography: TypographyOptions = {
  fontFamily: 'Space Grotesk',
  button: {
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'none',
    lineHeight: 1,
  },
  fontWeightBold: 700,
  fontWeightMedium: 700,
  fontWeightRegular: 400,

  h1: {
    fontSize: '2.25em',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h2: {
    fontSize: '2rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h3: {
    fontSize: '1.625rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h4: {
    fontSize: '1.5rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h5: {
    fontSize: '1.25rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h6: {
    fontSize: '1.125rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h7: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  h8: {
    fontSize: '0.75rem',
    lineHeight: 1.6,
    fontWeight: 700,
  },

  l1: {
    fontSize: '2.125rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l2: {
    fontSize: '1.75rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l3: {
    fontSize: '1.625rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l4: {
    fontSize: '1rem',
    lineHeight: 1.6,
    fontWeight: 500,
  },

  l5: {
    fontSize: '1rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l6: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l7: {
    fontSize: '0.75rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  l8: {
    fontSize: '0.6875rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },

  allVariants: {
    fontFamily: 'Space Grotesk',
  },
};
